import { CssCustomCodeIcon, JsCustomCodeIcon } from '@carboncopyco/icons';
import type { ISnippetRule } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { RulePreview } from '../../RulePreview';

const icons = {
  js: <JsCustomCodeIcon />,
  css: <CssCustomCodeIcon />,
};

export type CustomCodeSnippetPreviewProps = {
  snippet: ISnippetRule;
  disabled?: boolean;
};
export const CustomCodeSnippetPreview = ({
  snippet,
  disabled,
}: CustomCodeSnippetPreviewProps) => {
  return (
    <RulePreview>
      <div className={classNames(disabled && 'opacity-30')}>
        {icons[snippet.snippetType]}
      </div>
      <RulePreview.Tooltip title={snippet.name}>
        <span
          className={classNames(
            'truncate ',
            disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'
          )}
        >
          <TextBase
            label={snippet.name}
            color={disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'}
            ellipsis
          />
        </span>
      </RulePreview.Tooltip>
    </RulePreview>
  );
};
